import { AuthClientTokens } from "@react-keycloak/core/lib/types";
import { IAction } from "redux-micro-frontend";
import { AUTH_ACTIONS } from "../constants/constants";
import { AuthTokenStateDefault } from "../states/authTokenState";

export const logInAction = (authInfo: AuthClientTokens): IAction => {
  return {
    type: AUTH_ACTIONS.LOG_IN,
    payload: {
      ...authInfo,
      isLogged: true,
    },
  };
};

export const logOutAction = (): IAction => {
  return {
    type: AUTH_ACTIONS.LOG_OUT,
    payload: AuthTokenStateDefault,
  };
};
